// * Note: Please collect location info & logtime of each and every API Requests

// import axios from 'axios';

import { API_CONFIG } from "common/config";
import { COMMON_JS } from "common/scripts";

export const PRODUCT_APIs = {
  // Adding/Editing Taxes
  manageTaxMaster: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/457Q8623Y97241XY",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get Taxes
  getTaxMaster: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/4QSNH29YUE21K4FR",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Adding/Editing Grams
  manageGramsMaster: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/06I87M9Y6BVO1C5W",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get grams
  getGramsMaster: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/VT7O00HRCUCUAS6S",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Adding/Editing Product Main Category
  manageProductMainCategory: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/Z4SREC40LMEM2AIJ",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get Product Main Categories
  getProductMainCategory: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/JJ2CJ8EWPCROIQ4G",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Adding/Editing Product Sub Category
  manageProductSubCategory: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/XLK1MUKBSPW5Z54H",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get Product Sub Categories
  getProductSubCategory: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/QLB97Y5PYSI2R3E4",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Adding/Editing Product Sub Category
  manageProductTypeCategory: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/SHVX2KQJ5MSIKPXM",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get Product Sub Categories
  getProductTypeCategory: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/FPNEXYZWYW1WMB65",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Adding/Editing Product
  manageProduct: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/GMT1IXZYIH1NO17B",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get products
  getProducts: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/F2FV0ISUJ62Z6II9",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Adding/Editing Product SKU
  manageProductSku: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/Z1F41898PIAVBGH5",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get products SKU
  getProductsSku: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/pr/v1/31XTUQVIBM99HA39",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },
};
